import {FormDefinition} from "@t/fd/layout/FormDefinition";
import {InterfaceRoot} from "@t/fd/InterfaceRoot.ts";

export interface MetaProperties {
	form: InterfaceRoot<FormDefinition>
}

export interface WithMeta {
	META: MetaProperties
}

export type DataWithMeta<T> = T & WithMeta;

export function removeMeta<T>(data:DataWithMeta<T>):T {
	const copy = { ...data };
	delete copy.META;
	return copy as T;
}

export function appendMeta<T>(data: T, form: InterfaceRoot<FormDefinition>):DataWithMeta<T> {
	const copy:DataWithMeta<T> = {
		...data,
		META: {
			form
		}
	};
	return copy;
}